<div class="order-cancel">
  <div class="order-cancel__header">
    <span class="order-cancel__header__title">Anular servicio</span>
    <button mat-icon-button (click)="serviceCancelState.resetMutationState(); dialogRef.close()" data-testid="service-cancel-dialog-close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="order-cancel__container">
    @if (data.isAllowedToCancel) {
      <form [formGroup]="serviceCancelForm" class="order-cancel__body">
        <div class="order-cancel__body__info">
          <span>{{data.serviceId}}</span>
        </div>
        <div class="order-cancel__body__payment">
          <div class="payment">
            <div class="payment__box">
              <div class="payment__box__title">nombre</div>
              <div class="payment__box__value">
                {{ data.serviceDetail.descripcion }}
              </div>
            </div>
            <div class="payment__box">
              <div class="payment__box__title">Productos</div>
              <table class="payment__box__table">
                <tbody>
                  @for (product of  data.serviceDetail.productos; track product.sku) {
                    <tr>
                      <td class="product">
                        <div class="product__info">
                          <span>{{ product.descripcion }}</span>
                          <span>SKU: {{ product.sku }}</span>
                        </div>
                      </td>
                      <td class="unit">{{ product.cantidad }} un</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="order-cancel__body__observations" [formGroup]="serviceCancelForm">
          <div class="observations__header">
            <mat-icon fontSet="material-icons-outlined">note_alt</mat-icon>
            <span>OBSERVACIONES</span>
          </div>
          <textarea
            class="observations__textarea"
            placeholder="Escribe aquí..."
            formControlName="observations"
          ></textarea>
        </div>
      </form>
      <div class="order-cancel__footer">
        <div class="order-cancel__footer__options">
          <button horusBtn horusBtnSize="md" class="w-full" [disabled]="serviceCancelForm.invalid" (click)="onOpenConfirmServiceCancellation()" data-testid="service-cancel-dialog-submit-btn">ANULAR SERVICIO</button>
          <button horusBtn horusBtnVariant="outline-default" horusBtnSize="md" class="w-full" (click)="serviceCancelState.resetMutationState(); dialogRef.close()" data-testid="service-cancel-dialog-cancel-btn">CANCELAR</button>
        </div>
      </div>
    } @else {
      <div class="order-cancel__message" data-testid="service-cancel-dialog-not-allowed">
        <app-horus-message-general nameIcon="noDataMessageIcon" btnAction="ENTENDIDO" (action)="serviceCancelState.resetMutationState(); dialogRef.close()">
          <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">No podemos ejecutar la acción</span><br>
          <span  style="font-weight: 400;">Este servicio <strong>no cumple las condiciones para ser anulado</strong> .</span>
        </app-horus-message-general>
      </div>
    }
  </div>
</div>


<ng-template #confirmTemplate let-close="close">
  @if (serviceCancelState.isCancelling()) {
    <app-horus-loading data-testid="service-cancel-confirm-loading"></app-horus-loading>
  } @else if (serviceCancelState.hasCancelSuccess()) {
    <app-horus-message-general
      nameIcon="successMessageIcon"
      btnAction="ACEPTAR"
      size="M"
      (action)="closeAllDialogs()"
      data-testid="service-cancel-confirm-success">
      <div class="confirm__content">
        <span class="confirm__content__title confirm__content__title--success">¡Listo!</span>
        <span class="confirm__content__text">Anulaste el servicio de <br> manera correcta.</span>
      </div>
    </app-horus-message-general>
  } @else if (serviceCancelState.isBusinessRuleError()) {
    <app-horus-message-general
      size="M"
      nameIcon="noDataMessageIcon"
      btnAction="INGRESAR TICKET"
      btnCancel="CANCELAR"
      (action)="redirectToAria()"
      (actionCancel)="close()"
      data-testid="service-cancel-confirm-business-error">
      <div class="confirm__content">
        <span class="confirm__content__title" style="color:#F6D44D;">No podemos ejecutar la acción</span>
        <span class="confirm__content__text">Este servicio ya no puede ser anulado. Si aún deseas continuar con este proceso, ingresa un ticket.</span>
      </div>
    </app-horus-message-general>
  } @else if (serviceCancelState.isGeneralCancelError()) {
    <app-horus-message-general
      size="M"
      nameIcon="errorMessageIcon"
      btnAction="INTENTAR NUEVAMENTE"
      (action)="onConfirmServiceCancellation()"
      btnCancel="CANCELAR"
      (actionCancel)="close()"
      data-testid="service-cancel-confirm-general-error">
      <div class="confirm__content">
        <span class="confirm__content__title">Lo sentimos</span>
        <span class="confirm__content__text">Hubo un error al intentar anular <br> el servicio.</span>
      </div>
    </app-horus-message-general>
  } @else {
    <div class="confirm__body" data-testid="service-cancel-confirm-initial">
      <div class="confirm__body__icon">
        <mat-icon svgIcon="iconCar"></mat-icon>
      </div>
      <div class="confirm__body__message">
        <span>Estás a punto de anular este servicio.</span>
        <div class="confirm__body__warning">
          <mat-icon fontSet="material-icons-outlined">info</mat-icon>
          <div class="confirm__body__warning__content">
            <span class="confirm__body__warning__title">Reembolso de servicio</span>
            <span class="confirm__body__warning__text">Esta cancelación emite una orden que devolverá el monto total del servicio al mismo medio de pago en un plazo aproximado de hasta 22 días hábiles, dependiendo de la entidad financiera del cliente.</span>
          </div>
        </div>
        <span>¿Quieres confirmar la <strong>anulación</strong>?</span>
      </div>
      <div class="confirm__body__actions">
        <button horusBtn horusBtnVariant="outline-default" horusBtnSize="md" class="w-full" (click)="close()" data-testid="service-cancel-confirm-cancel-btn">CANCELAR</button>
        <button horusBtn horusBtnSize="md" class="w-full" (click)="onConfirmServiceCancellation()" data-testid="service-cancel-confirm-submit-btn">CONFIRMAR</button>
      </div>
    </div>
  }
</ng-template>
